import { render, staticRenderFns } from "./daohan.vue?vue&type=template&id=08229990&scoped=true&"
import script from "./daohan.vue?vue&type=script&lang=js&"
export * from "./daohan.vue?vue&type=script&lang=js&"
import style0 from "./daohan.vue?vue&type=style&index=0&id=08229990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08229990",
  null
  
)

export default component.exports